export const isInView = (container, element, reversed) => {
    if (!element) return false;
    const { top, bottom, height } = element.getBoundingClientRect();
    let _top = reversed ? window.innerHeight - bottom : top;
    const diff = height - (container.offsetTop - _top);
    return diff > 0;
};

export const getScrollDiff = (container, element, reversed) => {
    if (!container || !element) return 0;
    const { height: scrollerHeight, y: scrollerY } = container.getBoundingClientRect();
    const { height: elementHeight, y: elementY } = element.getBoundingClientRect();
    return reversed ? scrollerY + scrollerHeight - (elementY + elementHeight) : elementY - scrollerY;
};

export const getFirstVisible = (id, container, element) => {
    const { y: elementY } = element?.getBoundingClientRect() || {};
    const { y: containerY } = container?.getBoundingClientRect() || {};
    const offset = containerY - elementY || 0;

    return { id, offset };
}

export const getStartIndex = (data, reverse, cId, scrollAtStart, init, defaultIndex) => {
    let index = defaultIndex;
    if (cId && !scrollAtStart && !init) {
        index = getDataIndex(data, cId, reverse) || index;
    }
    return index;
}

export const getDataIndex = (data, id, reverse) => {
    let index;
    const idx = data.findIndex((item) => id === item.id);
    if (idx >= 0) {
        index = idx + (reverse ? 1 : 0)
    }
    return index
}
